<template>
  <div
    v-if="totalPages > 1 || totalElements > pageSize"
    class="flex flex-wrap items-center justify-between gap-3 my-3"
  >
    <div class="flex flex-wrap items-center gap-2">
      <button
        type="button"
        class="min-w-24 px-4 py-2 text-sm border rounded"
        :class="currentPage > 1 ? 'border-gray-300 text-primary hover:bg-gray-50' : 'border-gray-200 text-gray-400 cursor-not-allowed'"
        :disabled="currentPage <= 1"
        @click="$emit('previous')"
      >
        Previous
      </button>
      <span class="px-2 py-1 bg-primary text-white text-sm rounded">{{ currentPage }} / {{ totalPages || 1 }}</span>
      <button
        type="button"
        class="min-w-24 px-4 py-2 text-sm border rounded"
        :class="currentPage < totalPages ? 'border-gray-300 text-primary hover:bg-gray-50' : 'border-gray-200 text-gray-400 cursor-not-allowed'"
        :disabled="currentPage >= totalPages"
        @click="$emit('next')"
      >
        Next
      </button>
    </div>
    <div class="flex flex-wrap items-center gap-2">
      <label class="text-sm text-gray">Per page</label>
      <select
        :value="pageSize"
        class="px-3 py-2 text-sm border border-gray-300 rounded"
        @change="onSizeChange"
      >
        <option v-for="size in pageSizeOptions" :key="size" :value="size">{{ size }}</option>
      </select>
      <span class="text-xs font-bold text-gray-600">{{ rangeStart }} – {{ rangeEnd }} of {{ totalElements }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    currentPage: number
    totalPages: number
    totalElements: number
    pageSize: number
    rangeStart: number
    rangeEnd: number
    pageSizeOptions?: number[]
  }>(),
  { pageSizeOptions: () => [25, 50, 75, 100] },
);

const emit = defineEmits<{
  previous: []
  next: []
  "update:pageSize": [number]
}>();

const onSizeChange = (event: Event) => {
  const target = event.target as HTMLSelectElement;
  emit("update:pageSize", Number(target.value));
};
</script>
